<template>
	<div class="adminlogin">
		<div class="pageTitle">管理员登录</div>
		<van-form>
			<van-field
			v-model="mobile"
			name="mobile"
			type='tel'
			placeholder="输入手机号"
			/>
			<van-field
			v-model="code"
			name="code"
			placeholder="输入验证码"
			maxlength='6'
			type="digit"
			/>
			<div class="codebox">
				<div class="codetext" @click="getCode">{{codetext}}</div>
				<div class="codetime" v-if="showTime">({{codetime}})</div>
			</div>
			<div style="margin: 16px;display: flex;justify-content: space-between;">
				<van-button block color="#005DA3" @click="onSubmit" style="width: 45%;">
					登录
				</van-button>
				<van-button block type="default" @click="reset" style="width: 45%;">
					重置
				</van-button>
			</div>
		</van-form>
		<!-- <div style="margin:0 15px;">
			<van-button block color="#005DA3" @click="wechatLogin">
				微信授权登录
			</van-button>
		</div> -->
		<!-- <div style="margin: 16px;display: flex;justify-content: space-between;position: fixed;left: 0;right: 0;bottom: 50px;">
			<van-button block color="#005DA3" @click="wechatLogin" style="width: 45%;">
				授权登录
			</van-button>
			<van-button block type="default" @click="goBack" style="width: 45%;">
				取消
			</van-button>
		</div> -->
		<div style="margin: 16px;display: flex;justify-content: center;position: fixed;left: 0;right: 0;bottom: 60px;">
			<img style="width:30px;height:30px;" :src="img.wecheck" @click="wechatLogin" />
		</div>
	</div>
</template>
<script>
	import member from '../../api/member/memberinfo';
	import { mapState } from 'vuex';
	import { Button,Form,Field,Toast } from 'vant';
	export default {
		data () {
			return {
				codetext:'获取验证码',
				codetime:'60s',
				showTime:false,
				mobile:'',
				code:'',
				democode:'',
				img:{
					wecheck: require('../../assets/img/wecheck.png')
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.param.user,
				source: state => state.param.source
			})
		},
		watch: {
			'$route'() {
				if(this.$route.query.code){
					if(this.$route.query.code!=this.code) {
						Toast('登陆成功')
						this.code=this.$route.query.code
						Toast('watch='+this.$route.query.code)
						this.$router.go(-1);
				// this.getLogin(this.$route.query.code)
			}
		}
	}
},
created () {

	this.$store.commit('param/show', false)
},
methods: {
	onSubmit() {
		// alert('输入框的验证码==='+this.code)
		if(this.mobile){
			if(!(/^1[3456789]\d{9}$/.test(this.mobile))){
				this.$toast('请填写正确的手机号');
			}else{
				if(this.code){
					var params={
						mobile:this.mobile,
						code:this.code,
						source:99
					}
					member.Login(params).then(res => {
						if(res.data.state == 1) {
							let token=res.data.data.access_token
							localStorage.setItem('adminToken', token)
							var newTime=new Date()
							var Year = newTime.getFullYear()
							var Month = newTime.getMonth() + 1
							var Day = newTime.getDate() 
							var LoginTime=Year.toString()+Month.toString()+Day.toString()
							localStorage.setItem('LoginTime', LoginTime)
							this.$router.go(-1);
							// this.$router.push({name:'AdminHome',params:{token:this.token}});
						}else{
							Toast(res.data.error[0]);
						}
					})
					
				}else{
					Toast('请输入验证码！');
				}
			}
		}else{
			Toast('请输入手机号！');
		}
	},
	getCode(){
		if(this.mobile){
			if(!(/^1[3456789]\d{9}$/.test(this.mobile))){
				this.$toast('请填写正确的手机号');
			}else{
				if(!this.showTime){
					
					var params={
						mobile:this.mobile,
						source:9
					}
					member.getCode(params).then(res => {
						if(res.data.state == 1) {
							this.democode=res.data.data.code
							// alert('接口返回的验证码==='+res.data.data.code)
							this.showTime=true
							var count=60
							var timer
							var that=this
							timer = setInterval(function(){
								count--;
								that.codetime=count+'s'
								if (count <=0) {
									clearInterval(timer);
									that.codetime='60s'
									that.showTime=false
								}
							},1000);
						}else{

						}
					})
					
				}else{
					Toast('60秒内只能发送一次！');
				}
			}
		}else{
			Toast('请输入手机号！');
		}
	},
	reset(){
		this.mobile=''
		this.code=''
	},
	wechatLogin(){
		var newTime=new Date()
		var Year = newTime.getFullYear()
		var Month = newTime.getMonth() + 1
		var Day = newTime.getDate() 
		var LoginTime=Year.toString()+Month.toString()+Day.toString()
		localStorage.setItem('LoginTime', LoginTime)
		var local=window.location.href
		
		// https%3A%2F%2Fdev-m.motortimevip.com%2Fadmin%2Fhome
		window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd8669654e2c13e60&redirect_uri='+encodeURIComponent(local)+'&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect&connect_redirect=1'
	},
	goBack(){
		this.$router.go(-1);
	}
},
components: {
	[Form.name]: Form,
	[Button.name]:Button,
	[Field.name]:Field,
	[Toast.name]:Toast
}
}
</script>
<style lang="scss">
	.adminlogin{
		.van-form{
			padding-top: 5px;
		}
		.codebox{
			display: flex;
			padding: 15px 15px 0 15px;
			font-size:12px;
			align-items: center;
			.codetext{
				text-align: right;
				flex: 1;
				color: #0C08BF;
			}
			.codetime{
				margin-left: 5px;
				float: right;
				color: #999999;
			}
		}
		.van-cell::after{
			border-bottom: 0 solid #ebedf0;
		}
		.van-cell__value{
			padding:10px 15px;
			border: 1px solid #666666;
		}
	}
</style>
